module.exports = __webpack_public_path__ + "img/flightsite_logo_white.71b968c1.png";